import { createSlice } from '@reduxjs/toolkit'
import { Toast, config } from '../../../config/config'
import { login, register, resetPassword } from './thunk'
const initialState = {
    value: 0,
    logged: false,
    isError: false,
    email: '',
    name: '',
    token: '',
    error: '',
    isUpdated: false,
    isLoading: false

}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        logout: (state) => {
            state.logged = false;
            state.name = '';
            state.token = '';
            state.error = '';
            state.email = '';
            state.fullName = '';
            localStorage.clear(); // Remove the token and other stuff from local storage
        },
        // toastHandler: (state) => {
        //     state.error = '';
        //     state.isError = false;
        //     state.isUpdated = false;
        // }

    }, extraReducers: (builder) => {
        // Login
        builder.addCase(login.pending, (state) => {
            state.isLoading = true;
            state.logged = false;
        });
        builder.addCase(login.fulfilled, (state, action) => {
            state.logged = true;
            state.name = action.payload?.data?.fullName;
            state.token = action.payload?.data?.accessToken;
            state.email = action.payload?.data?.email;
            state.isLoading = false;
            localStorage.setItem(config.jwtToken, action.payload?.data?.accessToken);
            Toast.fire({
                icon: 'success',
                title: 'Success!'
              });
        });
        builder.addCase(login.rejected, (state, action) => {
            state.updateProfile = false;
            state.error = action.payload;
            state.isLoading = false;
            Toast.fire({
                icon: 'error',
                title: 'Invalid email or password!'
              });
        });


         // regsiter
         builder.addCase(register.pending, (state) => {
            state.isLoading = true;
            state.logged = false;
        });
        builder.addCase(register.fulfilled, (state, action) => {
            state.logged = true;
            state.name = action.payload?.data?.fullName;
            state.token = action.payload?.data?.accessToken;
            state.email = action.payload?.data?.email;
            state.isLoading = false;
            localStorage.setItem(config.jwtToken, action.payload?.data?.accessToken);
            Toast.fire({
                icon: 'success',
                title: 'Success!'
              });
        });
        builder.addCase(register.rejected, (state, action) => {
            state.updateProfile = false;
            state.error = action.payload;
            state.isLoading = false;
            Toast.fire({
                icon: 'error',
                title: 'Invalid email or password!'
              });
        }); 


         // reset password
         builder.addCase(resetPassword.pending, (state) => {
            state.isLoading = true;
            state.logged = false;
        });
        builder.addCase(resetPassword.fulfilled, (state, action) => {
            state.logged = true;
            state.name = action.payload?.data?.fullName;
            state.token = action.payload?.data?.accessToken;
            state.email = action.payload?.data?.email;
            state.isLoading = false;
            localStorage.setItem(config.jwtToken, action.payload?.data?.accessToken);
            Toast.fire({
                icon: 'success',
                title: 'Success!'
              });
        });
        builder.addCase(resetPassword.rejected, (state, action) => {
            state.updateProfile = false;
            state.error = action.payload;
            state.isLoading = false;
            Toast.fire({
                icon: 'error',
                title: 'Invalid email or password!'
              });
        }); 
    }
})

export const { logout,toastHandler } = authSlice.actions
export default authSlice.reducer
